import { render, staticRenderFns } from "./teacherInfoDialog.vue?vue&type=template&id=6b095892&"
import script from "./teacherInfoDialog.vue?vue&type=script&lang=js&"
export * from "./teacherInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./teacherInfoDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports